import Loader from '@components/Loader/Loader'
import Grid from '@config/Grid/Grid'
import styles from './LoadingPage.module.scss'

function LoadingPage() {
  return (
    <Grid>
      <div className={`start-6 col-2 ${styles.loadingPageWrapper}`}>
        <div className={styles.loadingPageContainer}>
          <p className={`logo-font ${styles.sideBarLogo}`}>
            <mark className="mark-white">MENU</mark>
            <mark className="mark-orange">!</mark>
          </p>
          <Loader size="large" />
          <div className={styles.loadingPageTextContainer}>
            <p className={`body-bold-small ${styles.loadingText}`}>
              Loading...
            </p>
            <p className={`title-bold-large ${styles.loadingStatus}`}>
              Preparing <mark className="mark-orange">dishes</mark>
            </p>
          </div>
        </div>
      </div>
    </Grid>
  )
}
export default LoadingPage
